import React from 'react'

function Layout(props) {
    return (
        <div className="container">
            {props.children}
        </div>
    )
}


Layout.Title = (props) => (
    <h1>{props.children}</h1>
)

Layout.Paragraph = (props) => (
    <p>{props.children}</p>
)



export default Layout
